
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  ViewChild,
  DOCUMENT
} from '@angular/core';

@Component({
  selector: 'app-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.scss'],
  standalone: false,
})
export class MenuListComponent implements AfterViewInit, OnDestroy {
  /* To get menuListContainer element from template */
  @ViewChild('menuListContainer', { static: true })
  private menuListContainer: ElementRef<HTMLDivElement>;
  private mutationObserver: MutationObserver;

  /**
   * Constructor
   * @param document
   * @param cd
   */
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private cd: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.detectHeaderChanges();
    this.cd.detectChanges();
    const sidenavContainer = this.document.getElementById('sidenav-container');
    if (sidenavContainer) {
      this.mutationObserver = new MutationObserver(() => {
        this.detectHeaderChanges();
      });
      this.mutationObserver.observe(sidenavContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    }
  }

  /* To set dynamic height of header */
  private detectHeaderChanges() {
    const sidenavHeader = this.document.getElementById('sidenav-header');
    if (!sidenavHeader) return;

    const menuListContainer = this.menuListContainer.nativeElement;
    const headerHeight = sidenavHeader.clientHeight || 0;

    // Check if payment dropdown is visible
    const paymentDropdown = this.document.querySelector(
      'app-payment-account-dropdown'
    );
    const isPaymentVisible =
      paymentDropdown &&
      window.getComputedStyle(paymentDropdown).display !== 'none';

    const extraHeight = isPaymentVisible ? 96 : 0;

    menuListContainer.style.setProperty(
      'max-height',
      `calc(100vh - ${headerHeight + extraHeight}px)`
    );
  }

  ngOnDestroy(): void {
    this.mutationObserver?.disconnect();
  }
}
